/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */

import { css, ClassNames } from '@emotion/react';
import styled from '@emotion/styled';
import { define, ui, s } from '@owenscorning/pcb.alpha';
import { useState, useEffect } from 'react';
import Slider from 'react-slick';

import { mdms } from '../../../../../api';
import useDeviceBreakpoint from '../../../../../hooks/use_device_breakpoint';
import Theme from '../../../../../themes';
import IconChevronRight from '../../../../ComponentLibrary/icons/icon-chevron-right';
import Modal from '../../../../Modal';
import { BasicContent } from '../../../../OC/PageBuilder/BasicContent';
import { H3 } from '../../../../OC/oc-h';
import Picture from '../../../../OC/oc-picture';
import { getParams, setParams } from '../../../../helpers/params';
import { connectLocation } from '../../../../location/LocationConnectors';

const Container = styled.div`
  display: flex;
  @media (max-width: 1199px) {
    display: block;
  }
`;
const Column = styled.div`
  flex: 1;
  margin: 15px;
`;
const ColorSelectorContainer = styled.div`
  border: 1px solid #6d6d6d;
  margin-bottom: 30px;
  padding: 16px;

  @media (max-width: 767px) {
    padding: 12px;
  }
`;
const ColorSelectorGrid = styled.div`
  display: grid;
  gap: 16px 12px;
  grid-template-columns: repeat(5, 1fr);
  margin-bottom: 24px;
  place-items: center;

  @media (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const ColorSelectorSlider = styled(Slider)`
  margin-bottom: 24px;
`;
const ColorImage = styled.img`
  aspect-ratio: 1;
  border: ${Theme.colors.brand};
  border-style: ${props => (props.selected ? 'solid' : 'none')};
  border-width: 4px;
  cursor: pointer;
  height: 98px;
  padding: ${props => (props.selected ? '4px' : '0px')};
  width: 98px;

  @media (max-width: 767px) {
    height: 73px;
    width: 73px;
  }
`;
const MainImage = styled.img`
  aspect-ratio: 1.5;
  margin-bottom: 16px;
  object-fit: cover;
  width: 100%;
`;
const BottomImageContainer = styled.div`
  aspect-ratio: 2;
  display: flex;
  gap: 16px;
`;
const BottomImage = styled.img`
  aspect-ratio: 1;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;
const zoomWrapperStyles = css`
  position: relative;
  cursor: pointer;

  img {
    display: block;
  }

  .fa {
    background: rgba(0, 0, 0, 0.5);
    border-right: 1px white solid;
    border-top: 1px white solid;
    bottom: 0;
    color: #fff;
    font-size: 24px;
    left: 0;
    padding: 12px;
    position: absolute;
  }
`;
const bottomZoomWrapperStyles = css`
  max-width: 50%;
  min-width: 0;
`;
const TopCarouselContainer = styled.div`
  margin-bottom: 46px;
`;
const TopCarouselImage = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  width: 100%;
`;
const arrowStyles = css`
  cursor: pointer;
  height: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  z-index: 1;
  filter: invert(1) drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25));
`;
const nextArrowStyles = css`
  ${arrowStyles};
  right: 8px;
`;
const prevArrowStyles = css`
  ${arrowStyles};
  left: 8px;
  transform: translateY(-50%) scaleX(-1);
`;
const brandedDotStyles = css`
  bottom: -22px;

  li {
    margin: 0 4px;

    &, button {
      height: 12px;
      width: 12px;
    }

    button {
      background-color: #a8a8a8;
      border-radius: 100%;

      &:before {
        border-radius: 100%;
        content: '';
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &.slick-active {
      button {
        background-color: ${Theme.colors.brand};

        &:before {
          border: 1px solid ${Theme.colors.brand};
        }
      }
    }
  }
`;
const ColorItemCarouselContainer = styled.div`
  margin: 0 4px;

  &:focus {
    outline: 0;
    outline: none;
  }
`;
const SmallArrowGradientContainer = styled.div`
  background: linear-gradient(
    ${props => (props.prevArrow ? `-90deg` : `90deg`)},
    rgba(238, 238, 238, 0) 0%,
    #fff 100%,
    #d8d8d8 100%
  );
  cursor: pointer;
  height: 100%;
  position: absolute;
  ${props => (props.prevArrow ? `left: 0px;` : `right: 0px;`)}
  top: 0px;
  width: 28px;
  z-index: 1;
`;
const SmallArrow = styled.div`
  filter: invert(1) drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25));
  height: 16px;
  position: absolute;
  left: 50%;
  stroke-width: 2px;
  top: 50%;
  transform: translate(-50%, -50%) ${props => props.prevArrow && `scaleX(-1)`};
  width: 8px;
`;

const CarouselArrow = ({ className, onClick, prevArrow }) =>
  !className?.includes('slick-disabled') && (
    <div css={prevArrow ? prevArrowStyles : nextArrowStyles} onClick={onClick}>
      <IconChevronRight />
    </div>
  );

const ZoomWrapper = ({ children }) => (
  <div css={zoomWrapperStyles}>
    <span className="fa fa-search-plus" />
    {children}
  </div>
);

const TopCarouselItem = ({ imageUrl, name, clickHandler }) => (
  <ZoomWrapper>
    <TopCarouselImage src={imageUrl} onClick={clickHandler} alt={name} />
  </ZoomWrapper>
);

const ColorSelectorCarouselArrow = ({ className, onClick, prevArrow }) =>
  !className?.includes('slick-disabled') && (
    <SmallArrowGradientContainer prevArrow={prevArrow} onClick={onClick}>
      <SmallArrow prevArrow={prevArrow}>
        <IconChevronRight />
      </SmallArrow>
    </SmallArrowGradientContainer>
  );

const ColorSelector = ({ shingleColors, selectedColor, setSelectedColor, isPhone, pageSlug, t }) => {
  const colorItems = shingleColors?.map(color => (
    <ColorImage
      key={color.uid}
      uid={color.uid}
      src={color.swatch_160x160_image_url}
      alt={color.name}
      data-track="view product"
      data-track-product-name={pageSlug}
      data-track-product-color={color.name}
      selected={selectedColor?.uid === color.uid}
      onClick={() => {
        setSelectedColor(color);
        setParams({ 'shingle-color': color?.uid });
      }}
    />
  ));

  const grid = <ColorSelectorGrid>{colorItems}</ColorSelectorGrid>;

  const carousel = (
    <ColorSelectorSlider
      infinite={false}
      nextArrow={<ColorSelectorCarouselArrow />}
      prevArrow={<ColorSelectorCarouselArrow prevArrow />}
      variableWidth
      swipeToSlide
    >
      {colorItems.map(colorItem => (
        <ColorItemCarouselContainer>{colorItem}</ColorItemCarouselContainer>
      ))}
    </ColorSelectorSlider>
  );
  return (
    <ColorSelectorContainer>
      {isPhone ? carousel : grid}
      <span>{t(`shingles.color_selected`)}</span>
      <H3 font="body">{selectedColor?.name}</H3>
      <p>{selectedColor?.description}</p>
    </ColorSelectorContainer>
  );
};

const Render = connectLocation(
  ({ pageSlug, heading, bodyCopy, showColorAccuracyAlert, bottomImage1, bottomImage2, zip, locale, t }) => {
    const [shingleLineData, setShingleLineData] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [currentModalImage, setCurrentModalImage] = useState(null);
    const { isPhone } = useDeviceBreakpoint();

    const clickHandler = (url, title) => {
      setCurrentModalImage({ url, title });
    };

    useEffect(() => {
      mdms
        .get(`/api/v2/product/shingles/${pageSlug}?zip=${zip}&lang=${locale.code}`)
        .then(response => response.json())
        .then(responseJson => {
          if (!responseJson?.data?.shingle_colors?.length) {
            setShingleLineData(null);
            setSelectedColor(null);
            return;
          }
          setShingleLineData(responseJson?.data);
          const searchParamColor =
            responseJson?.data?.shingle_colors?.find(color => color?.uid === getParams()['shingle-color']) ??
            responseJson?.data?.shingle_colors?.[0];
          setParams({ 'shingle-color': searchParamColor?.uid });
          setSelectedColor(searchParamColor);
        });
    }, [pageSlug]);

    if (!selectedColor) {
      return null;
    }

    // for desktop and tablet
    const secondColumn = (
      <Column>
        <ZoomWrapper>
          <MainImage
            src={selectedColor?.swatch_768x768_url}
            onClick={() => {
              clickHandler(selectedColor?.swatch_image_url, selectedColor?.name);
            }}
            data-track="zoom"
            data-track-image-name={selectedColor?.swatch_768x768_url}
            data-track-product-name={pageSlug}
            data-track-product-color={selectedColor?.name}
          />
        </ZoomWrapper>
        <ZoomWrapper>
          <MainImage
            src={selectedColor?.house_1229x768_url}
            onClick={() => {
              clickHandler(selectedColor?.house_image_url, selectedColor?.name);
            }}
            data-track="zoom"
            data-track-image-name={selectedColor?.house_1229x768_url}
            data-track-product-name={pageSlug}
            data-track-product-color={selectedColor?.name}
          />
        </ZoomWrapper>
        {(bottomImage1?.file || bottomImage2?.file) && (
          <BottomImageContainer>
            {bottomImage1?.file && (
              <ZoomWrapper css={bottomZoomWrapperStyles}>
                <BottomImage
                  src={Picture.DefaultOrCrop(bottomImage1?.file, bottomImage1?.crop)}
                  onClick={() => {
                    clickHandler(bottomImage1?.file, bottomImage1?.alt);
                  }}
                  alt={bottomImage1?.alt}
                />
              </ZoomWrapper>
            )}
            {bottomImage2?.file && (
              <ZoomWrapper css={bottomZoomWrapperStyles}>
                <BottomImage
                  src={Picture.DefaultOrCrop(bottomImage2?.file, bottomImage2?.crop)}
                  onClick={() => {
                    clickHandler(bottomImage2?.file, bottomImage2?.alt);
                  }}
                  alt={bottomImage2?.alt}
                />
              </ZoomWrapper>
            )}
          </BottomImageContainer>
        )}
      </Column>
    );

    // for mobile only
    const mobileTopCarousel = (
      <TopCarouselContainer>
        <ClassNames>
          {classNames => (
            <Slider
              dots
              dotsClass={`hero-slick-dots ${classNames.css(brandedDotStyles)}`}
              nextArrow={<CarouselArrow />}
              prevArrow={<CarouselArrow prevArrow />}
            >
              <TopCarouselItem
                imageUrl={selectedColor?.swatch_768x768_url}
                name={selectedColor?.name}
                clickHandler={() => {
                  clickHandler(selectedColor?.swatch_image_url, selectedColor?.name);
                }}
              />
              <TopCarouselItem
                imageUrl={selectedColor?.house_1229x768_url}
                name={selectedColor?.name}
                clickHandler={() => {
                  clickHandler(selectedColor?.house_image_url, selectedColor?.name);
                }}
              />
              <TopCarouselItem
                imageUrl={Picture.DefaultOrCrop(bottomImage1?.file, bottomImage1?.crop)}
                name={bottomImage1?.alt}
                clickHandler={() => {
                  clickHandler(bottomImage1?.file, bottomImage1?.alt);
                }}
              />
              <TopCarouselItem
                imageUrl={Picture.DefaultOrCrop(bottomImage2?.file, bottomImage2?.crop)}
                name={bottomImage2?.alt}
                clickHandler={() => {
                  clickHandler(bottomImage2?.file, bottomImage2?.alt);
                }}
              />
            </Slider>
          )}
        </ClassNames>
      </TopCarouselContainer>
    );

    return (
      <>
        <Container>
          <Column>
            <BasicContent heading={heading} bodyCopy={bodyCopy} />
            {isPhone && mobileTopCarousel}
            <ColorSelector
              shingleColors={shingleLineData?.shingle_colors}
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
              isPhone={isPhone}
              pageSlug={pageSlug}
              t={t}
            />
            {showColorAccuracyAlert && (
              <Subschema>
                {{
                  modules: ui`Modules/Page/Reusable|view`({
                    gutterlessChild: true,
                    skipContainers: true,
                    value: {
                      language: locale?.code,
                      name: 'Shingle Color Accuracy Disclaimer',
                      path: 'roofing',
                    },
                  }),
                }}
              </Subschema>
            )}
          </Column>
          {!isPhone && secondColumn}
        </Container>
        <Modal open={currentModalImage} onClose={() => setCurrentModalImage(null)} className="no-borders gallery-modal">
          <img src={currentModalImage?.url} alt={currentModalImage?.title} />
        </Modal>
      </>
    );
  }
);

export default define`Shingle Color and Image`('1.0.0')({
  thumbnail: ui`Modules/Page/Thumbnails/ShingleColorAndImage`,
  view: ({ Board, value }) => <Render pageSlug={Board?.build?.slug} {...value} />,
  edit: ui`Form`.of({
    heading: ui`Text/Rich`({ label: 'Heading' }),
    bodyCopy: ui`Text/Rich`({ label: 'Body Copy' }),
    [s._]: ui`Separator`(),
    colorSelector: ui`Form`.of({
      [s._]: ui`Tip`.of(
        `Each color has its own images and description. These can be configured in the Shingle Color Builder.`
      ),
    })({
      label: 'Color Selector',
    }),
    showColorAccuracyAlert: ui`Switch`({
      label: 'Alert Message',
      default: true,
    }),
    [s._]: ui`Tip`.of(
      `This message will display a disclaimer about computer monitor color variations and is not editable.`
    ),
    [s._]: ui`Separator`(),
    [s._]: ui`Heading`({ heading: `Shingle Line Images` }),
    [s._]: ui`AlertMessage`({
      message:
        'images should be a <b>minimum width of 870px</b>. These images will not change based on the users color selection.',
    }),
    bottomImage1: ui`Image`({
      crop: true,
      label: 'Bottom Image 1',
    }),
    bottomImage2: ui`Image`({
      crop: true,
      label: 'Bottom Image 2',
    }),
  }),
});
